export function getDeviceStylesIdentity(deviceType) {
  if (deviceType === 'phone') {
    return deviceType;
  }

  return 'desktop';
}
export function getDeviceStyles(deviceType) {
  if (deviceType === 'phone') {
    return require('./phone.css');
  }

  return require('./tablet-desktop.css');
}